// ---------------------------------------------
// auto-generated from materia/course-deeper.jsx
// edit the source there and run `npm run sync`
// ---------------------------------------------
import React from "react";
import { MChip, MEye, MNotAdvice, MChart } from "./prims.jsx";
import { Icon } from "../screens-cristal/primitives.jsx";
import { CourseShell } from "./course.jsx";

// ─────────────────────────────────────────────────────────
// 1. Course · Module Lab (3-pane: steps + chart + tutor)
// ─────────────────────────────────────────────────────────
export const ScreenMCLab = () => (
  <CourseShell
    label="Course · Module Lab · 3-pane"
    current={2}
    sourceProps={{ note: "M2 Lab · construir vela desde OHLC · explora estructura · tutor persistente" }}
    right={
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", background: "rgba(0,0,0,0.18)" }}>
        <div style={{ display: "flex", height: 38, borderBottom: "1px solid var(--m-line)", background: "var(--m-metal)" }}>
          {[{ l: "Tutor", on: true }, { l: "Fuente" }, { l: "Glosario" }].map((t, i) => (
            <div key={i} style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "var(--m-t-mono)", fontSize: 10.5, letterSpacing: "0.1em", textTransform: "uppercase",
              color: t.on ? "var(--m-text)" : "var(--m-text-3)",
              borderBottom: t.on ? "2px solid var(--m-primary)" : "2px solid transparent",
            }}>{t.l}</div>
          ))}
        </div>
        <div style={{ flex: 1, padding: 16, overflow: "auto", display: "flex", flexDirection: "column", gap: 12 }}>
          <div className="m-chip" style={{
            background: "rgba(155,184,106,0.10)", borderColor: "rgba(155,184,106,0.32)", color: "var(--m-positive)",
            alignSelf: "flex-start",
          }}>
            <Icon name="shield" size={10}/> Tutor socrático · sin recomendaciones
          </div>
          <div style={{ padding: 12, borderRadius: 6, background: "rgba(216,168,104,0.06)", border: "1px solid rgba(216,168,104,0.2)" }}>
            <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.1em" }}>TUTOR · CARLOS</div>
            <div style={{ fontSize: 12.5, marginTop: 6, lineHeight: 1.4 }}>
              Has puesto C debajo de O. Si C &lt; O, ¿qué color tendrá el cuerpo de tu vela? ¿Qué dice eso del sentimiento del día?
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {[
              { i: "lightbulb", l: "Pista · 1/3" },
              { i: "book",      l: "Glosario · cuerpo / mecha" },
              { i: "link",      l: "Fuente · OHLC dataset" },
              { i: "retry",     l: "Reformula pregunta" },
            ].map((a, i) => (
              <button key={i} className="m-btn ghost sm" style={{ justifyContent: "flex-start" }}>
                <Icon name={a.i} size={11}/> {a.l}
              </button>
            ))}
          </div>

          <div className="m-divider"/>
          <MEye>Conceptos cercanos</MEye>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {["cuerpo", "mecha", "OHLC", "doji", "spinning top"].map((t, i) => (
              <span key={i} className="m-chip neutral" style={{ height: 22, fontSize: 10 }}>{t}</span>
            ))}
          </div>

          <div className="m-divider"/>
          <MEye>Lo que has aprendido en este lab</MEye>
          <div style={{ fontSize: 12, color: "var(--m-text-2)", lineHeight: 1.4 }}>
            · Construir cuerpo y mecha desde O, H, L, C<br/>
            · Distinguir vela alcista / bajista por C ↔ O<br/>
            · Reconocer doji (cuerpo casi nulo)
          </div>
        </div>
      </div>
    }
    center={
      <div style={{ flex: 1, padding: "24px 32px 0", display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <MChip variant="copper">LAB · M2 · construir vela</MChip>
          <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>paso 2 de 3</span>
          <span style={{ flex: 1, height: 1, background: "var(--m-line)" }}/>
          <button className="m-btn ghost sm"><Icon name="x" size={11}/> Salir lab</button>
        </div>

        <h2 style={{ fontSize: 22, fontWeight: 600, marginTop: 14, lineHeight: 1.25, letterSpacing: "-0.015em" }}>
          Construye la vela desde valores <span style={{ color: "var(--m-accent)" }}>OHLC</span> reales.
        </h2>

        {/* steps */}
        <div style={{ marginTop: 18, display: "flex", gap: 4 }}>
          {[
            { n: 1, t: "Cargar OHLC", s: "done" },
            { n: 2, t: "Marcar cuerpo y mecha", s: "now" },
            { n: 3, t: "Clasificar tipo de vela", s: "todo" },
          ].map((s, i) => (
            <div key={i} style={{
              flex: 1, padding: "10px 12px", borderRadius: 4,
              background: s.s === "now" ? "rgba(201,122,75,0.10)" : "var(--m-metal-2)",
              border: `1px solid ${s.s === "done" ? "rgba(155,184,106,0.4)" : s.s === "now" ? "var(--m-primary)" : "var(--m-line)"}`,
            }}>
              <div className="mono" style={{ fontSize: 10, color: s.s === "done" ? "var(--m-positive)" : s.s === "now" ? "var(--m-primary)" : "var(--m-text-3)", letterSpacing: "0.06em" }}>
                {s.s === "done" ? "✓ " : ""}PASO {s.n}
              </div>
              <div style={{ fontSize: 12.5, marginTop: 4 }}>{s.t}</div>
            </div>
          ))}
        </div>

        {/* OHLC inputs + preview */}
        <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: 18, flex: 1, minHeight: 0 }}>
          <div className="m-panel" style={{ padding: 16 }}>
            <MEye>Datos OHLC · 2026-05-16 · XYZ</MEye>
            <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
              {[
                { l: "O · apertura", v: "101.20", c: "var(--m-text)" },
                { l: "H · máximo",   v: "103.60", c: "var(--m-positive)" },
                { l: "L · mínimo",   v: "100.80", c: "var(--m-negative)" },
                { l: "C · cierre",   v: "103.20", c: "var(--m-text)" },
              ].map((f, i) => (
                <div key={i} className="m-panel-sunk" style={{ padding: 10 }}>
                  <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>{f.l}</div>
                  <div className="mono" style={{ fontSize: 22, color: f.c, marginTop: 4, fontWeight: 500 }}>{f.v}</div>
                </div>
              ))}
            </div>

            <div className="m-divider" style={{ margin: "16px 0" }}/>
            <MEye>Tu construcción</MEye>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12 }}>
                <input type="checkbox" defaultChecked style={{ accentColor: "var(--m-positive)" }}/>
                <span>El cuerpo va de <span className="mono">101.20</span> a <span className="mono">103.20</span></span>
                <Icon name="check" size={12} style={{ color: "var(--m-positive)", marginLeft: "auto" }}/>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12 }}>
                <input type="checkbox" defaultChecked style={{ accentColor: "var(--m-positive)" }}/>
                <span>Mecha superior llega a <span className="mono">103.60</span></span>
                <Icon name="check" size={12} style={{ color: "var(--m-positive)", marginLeft: "auto" }}/>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12 }}>
                <input type="checkbox" style={{ accentColor: "var(--m-warn)" }}/>
                <span>Mecha inferior llega a <span className="mono">100.80</span></span>
                <Icon name="circle" size={12} style={{ color: "var(--m-warn)", marginLeft: "auto" }}/>
              </label>
            </div>
          </div>

          <div className="m-panel" style={{ padding: 16, display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <MEye>Preview · tu vela</MEye>
              <MChip variant="live">live</MChip>
            </div>
            <div style={{ flex: 1, display: "grid", placeItems: "center", padding: 14, minHeight: 220 }}>
              <svg width="120" height="240" viewBox="0 0 120 240">
                {/* upper wick */}
                <line x1="60" y1="20" x2="60" y2="55" stroke="var(--m-text-2)" strokeWidth="1.5"/>
                {/* body */}
                <rect x="40" y="55" width="40" height="100" fill="var(--m-positive)" opacity="0.85" stroke="#0f1a06" strokeWidth="1"/>
                {/* lower wick (uncertain — dashed) */}
                <line x1="60" y1="155" x2="60" y2="220" stroke="var(--m-warn)" strokeWidth="1.5" strokeDasharray="3 3"/>
                {/* labels */}
                <text x="86" y="20" fontFamily="var(--m-t-mono)" fontSize="10" fill="var(--m-text-3)">103.60 · H</text>
                <text x="86" y="60" fontFamily="var(--m-t-mono)" fontSize="10" fill="var(--m-text)">103.20 · C</text>
                <text x="86" y="155" fontFamily="var(--m-t-mono)" fontSize="10" fill="var(--m-text)">101.20 · O</text>
                <text x="86" y="220" fontFamily="var(--m-t-mono)" fontSize="10" fill="var(--m-warn)">100.80 · L · falta</text>
              </svg>
            </div>
            <div style={{ marginTop: "auto", padding: 10, borderRadius: 4, background: "rgba(216,168,104,0.08)", border: "1px solid rgba(216,168,104,0.25)" }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-warn)", letterSpacing: "0.08em", textTransform: "uppercase" }}>aún no terminada</div>
              <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 4 }}>Te falta marcar la mecha inferior. Sin ella, no podrías distinguir esta vela de una de cierre abierto.</div>
            </div>
          </div>
        </div>

        {/* mini player + send */}
        <div style={{ marginTop: 14, marginBottom: 14, display: "flex", gap: 10, alignItems: "center" }}>
          <div className="m-panel" style={{ flex: 1, padding: "8px 12px", display: "flex", alignItems: "center", gap: 10 }}>
            <Icon name="pause" size={12} style={{ color: "var(--m-text-2)" }}/>
            <div style={{ flex: 1, height: 3, background: "rgba(216,196,160,0.12)", borderRadius: 2 }}>
              <div style={{ width: "55%", height: "100%", background: "var(--m-text-2)" }}/>
            </div>
            <span className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)" }}>M2 · 22 / 35 min</span>
          </div>
          <button className="m-btn ghost"><Icon name="lightbulb" size={13}/> Pista 1/3</button>
          <button className="m-btn accent lg"><Icon name="check" size={14}/> Enviar paso</button>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 2. Course · LiveCaseSlot
// ─────────────────────────────────────────────────────────
export const ScreenMCLiveCase = () => (
  <CourseShell
    label="Course · LiveCaseSlot"
    current={3}
    sourceProps={{ note: "Live case semanal · marcado not-advice · no contamina progreso si cae" }}
    center={
      <div style={{ flex: 1, padding: "24px 32px", display: "flex", flexDirection: "column", overflow: "auto" }}>
        <div style={{
          padding: "12px 16px", borderRadius: 4,
          background: "rgba(155,184,106,0.10)", border: "1px solid rgba(155,184,106,0.35)",
          display: "flex", alignItems: "center", gap: 12,
        }}>
          <span style={{ width: 8, height: 8, borderRadius: 99, background: "var(--m-positive)", boxShadow: "0 0 12px var(--m-positive)" }}/>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 13, fontWeight: 600 }}>Caso vivo · semana 20 · ruptura ambigua en XYZ</div>
            <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 2 }}>Ejemplo educativo. No representa recomendación ni señal de operativa.</div>
          </div>
          <MChip variant="live">live · 14:32 UTC</MChip>
        </div>

        <h2 className="m-serif" style={{ fontSize: 32, fontWeight: 600, lineHeight: 1.15, letterSpacing: "-0.025em", marginTop: 18, fontStyle: "normal" }}>
          Esta semana: una ruptura <em style={{ color: "var(--m-accent)" }}>ambigua</em>.
        </h2>
        <div style={{ fontSize: 14, color: "var(--m-text-2)", marginTop: 6, maxWidth: 760, lineHeight: 1.45, textWrap: "pretty" }}>
          Misma idea que en la microclase de M3. Aquí practicas sobre datos reales del mercado en curso, sin que tu nivel del módulo dependa del resultado.
        </div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1.6fr 1fr", gap: 20, flex: 1, minHeight: 0 }}>
          <MChart width={580} height={400} caption="XYZ · 1D · 50 sesiones · live"
            overlays={[
              { type: "zone", topPct: 24, bottomPct: 32, color: "copper", label: "R · 101.5 — 102.4" },
              { type: "marker", xPct: 78, yPct: 22, label: "decisión", kind: "decision" },
              { type: "hline", yPct: 70, color: "rgba(216,196,160,0.3)", dashed: true, label: "S" },
            ]}/>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            <div className="m-panel" style={{ padding: 16 }}>
              <MEye>Ejercicios · 2 sobre caso vivo</MEye>
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                <div className="m-panel-sunk" style={{ padding: 12 }}>
                  <span className="mono" style={{ fontSize: 9.5, color: "var(--m-primary)", letterSpacing: "0.08em" }}>EJERCICIO 1</span>
                  <div style={{ fontSize: 13.5, marginTop: 4, fontWeight: 500 }}>¿Qué evidencia falta?</div>
                  <div style={{ fontSize: 11, color: "var(--m-text-3)", marginTop: 4 }}>EX.combine_concepts · 4 evidencias</div>
                </div>
                <div className="m-panel-sunk" style={{ padding: 12 }}>
                  <span className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", letterSpacing: "0.08em" }}>EJERCICIO 2</span>
                  <div style={{ fontSize: 13.5, marginTop: 4, fontWeight: 500 }}>¿Cómo clasificarías el caso?</div>
                  <div style={{ fontSize: 11, color: "var(--m-text-3)", marginTop: 4 }}>EX.multiple_choice · 4 opciones</div>
                </div>
              </div>
            </div>

            <div className="m-misconception" style={{ padding: 14 }}>
              <div className="lbl">freeze recomendado</div>
              <div style={{ fontSize: 11.5, color: "var(--m-text-2)", marginTop: 6, lineHeight: 1.4 }}>
                El sistema pausará en la vela 47 para que decidas con la misma información que tenías un trader ese día.
              </div>
            </div>

            <button className="m-btn primary lg" style={{ marginTop: "auto" }}>
              <Icon name="play" size={14}/> Empezar caso vivo
            </button>
            <button className="m-btn ghost sm" style={{ alignSelf: "flex-start" }}>
              <Icon name="globe" size={11}/> Saltar al fallback histórico
            </button>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 3. Course · TutorClinic
// ─────────────────────────────────────────────────────────
export const ScreenMCTutorClinic = () => (
  <CourseShell
    label="Course · TutorClinic"
    current={3}
    sourceProps={{ note: "TutorClinic · 15 min · trabajo dirigido sobre 3 misconceptions detectadas" }}
    center={
      <div style={{ flex: 1, padding: "24px 32px", display: "flex", flexDirection: "column", overflow: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <MChip variant="warn">TUTOR CLINIC · 15 min</MChip>
            <span className="mono" style={{ fontSize: 11, color: "var(--m-text-3)" }}>misconception 1 de 3</span>
          </div>
          <div className="m-chip" style={{
            background: "rgba(155,184,106,0.10)", borderColor: "rgba(155,184,106,0.32)", color: "var(--m-positive)",
          }}>
            <Icon name="shield" size={10}/> sin recomendaciones · solo razonamiento
          </div>
        </div>

        <h2 style={{ fontSize: 24, fontWeight: 600, marginTop: 14, lineHeight: 1.25, letterSpacing: "-0.015em" }}>
          Misconception · <em className="m-serif" style={{ color: "var(--m-accent)", fontStyle: "normal" }}>"color de vela = cambio de tendencia"</em>
        </h2>
        <div style={{ fontSize: 13, color: "var(--m-text-2)", marginTop: 8 }}>Detectada en M3 · ej. 5. El tutor te guiará a corregirla sin darte la respuesta.</div>

        <div style={{ marginTop: 22, display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 24, flex: 1, minHeight: 0 }}>
          {/* Chart of misconception case */}
          <div>
            <MChart width={560} height={300} caption="XYZ · 1D · ejemplo de la misconception"
              overlays={[
                { type: "trend", from: [12, 78], to: [90, 28], color: "rgba(155,184,106,0.5)" },
                { type: "marker", xPct: 70, yPct: 38, label: "vela roja", kind: "x" },
                { type: "swing", xPct: 82, yPct: 36, label: "HL" },
              ]}/>
            <div className="m-divider" style={{ margin: "14px 0" }}/>
            <MEye>Las 3 misconceptions de la clínica</MEye>
            <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
              {[
                { t: "Color de vela = cambio de tendencia", on: true },
                { t: "Soporte como línea exacta" },
                { t: "RSI alto = vender" },
              ].map((m, i) => (
                <div key={i} className="m-panel" style={{
                  padding: "8px 12px", display: "flex", alignItems: "center", gap: 10,
                  background: m.on ? "rgba(201,122,75,0.10)" : "var(--m-metal-2)",
                  borderColor: m.on ? "var(--m-primary)" : "var(--m-line)",
                }}>
                  <span className="mono" style={{ fontSize: 9.5, color: m.on ? "var(--m-primary)" : "var(--m-text-3)", width: 20 }}>0{i+1}</span>
                  <span style={{ flex: 1, fontSize: 12 }}>{m.t}</span>
                  {m.on && <Icon name="play" size={11} style={{ color: "var(--m-primary)" }}/>}
                </div>
              ))}
            </div>
          </div>

          {/* Conversation pane */}
          <div className="m-panel" style={{ padding: 18, display: "flex", flexDirection: "column" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: 99, background: "rgba(216,168,104,0.16)", display: "grid", placeItems: "center" }}>
                <Icon name="help" size={15} style={{ color: "var(--m-accent)" }}/>
              </div>
              <div>
                <div style={{ fontSize: 13.5, fontWeight: 600 }}>Carlos · tutor MCP</div>
                <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)" }}>socrático · 1 idea por mensaje</div>
              </div>
            </div>

            <div style={{ flex: 1, marginTop: 14, display: "flex", flexDirection: "column", gap: 10 }}>
              <div style={{ padding: 12, borderRadius: "8px 8px 8px 2px", background: "rgba(216,168,104,0.08)", border: "1px solid rgba(216,168,104,0.22)" }}>
                <div style={{ fontSize: 13, lineHeight: 1.45 }}>
                  Antes de mirar la vela: ¿qué evidencia te haría <em>cambiar de opinión</em> sobre la tendencia?
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div style={{ maxWidth: 280, padding: 10, borderRadius: "8px 8px 2px 8px", background: "var(--m-metal-2)", border: "1px solid var(--m-line)", fontSize: 12.5, lineHeight: 1.4 }}>
                  Mínimos decrecientes consecutivos, no una vela aislada.
                </div>
              </div>
              <div style={{ padding: 12, borderRadius: "8px 8px 8px 2px", background: "rgba(216,168,104,0.08)", border: "1px solid rgba(216,168,104,0.22)" }}>
                <div style={{ fontSize: 13, lineHeight: 1.45 }}>
                  Buen criterio. Ahora mira el chart de la izquierda. ¿La vela roja deja un mínimo decreciente?
                </div>
              </div>
            </div>

            <textarea placeholder="Tu respuesta (1-2 frases)" rows={3} style={{
              marginTop: 12, padding: 10, fontFamily: "var(--m-t-sans)", fontSize: 12,
              background: "var(--m-bg-deep)", border: "1px solid var(--m-line)", borderRadius: 4,
              color: "var(--m-text)", resize: "none",
            }}/>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8 }}>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="m-iconbtn" style={{ width: 30, height: 30 }}><Icon name="mic" size={11}/></button>
              </div>
              <button className="m-btn accent sm"><Icon name="send" size={11}/> Enviar</button>
            </div>
          </div>
        </div>
      </div>
    }
  />
);

// ─────────────────────────────────────────────────────────
// 4. Course · Complete
// ─────────────────────────────────────────────────────────
export const ScreenMCComplete = () => (
  <CourseShell
    label="Course · Complete"
    leftRail={false}
    current={6}
    sourceProps={{ note: "Curso completado · certificado pedagógico · spaced_recall activo" }}
    center={
      <div style={{ flex: 1, padding: "40px 64px", overflow: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 30 }}>
          <div>
            <MEye>Curso completado · 17 de mayo de 2026</MEye>
            <h1 className="m-serif" style={{ fontSize: 56, fontWeight: 600, lineHeight: 1.0, letterSpacing: "-0.03em", margin: "12px 0 10px", fontStyle: "normal" }}>
              Has aprendido a leer<br/>gráficos <em style={{ color: "var(--m-accent)" }}>sin autoengañarte</em>.
            </h1>
            <div style={{ fontSize: 17, color: "var(--m-text-2)", maxWidth: 620, lineHeight: 1.45, textWrap: "pretty" }}>
              5 módulos, 1 proyecto, 0 misconceptions retenidas. La parte difícil empieza ahora: usar lo aprendido sin perder el criterio.
            </div>
          </div>

          {/* Pedagogical certificate */}
          <div className="m-panel" style={{
            width: 380, padding: 24, position: "relative", overflow: "hidden",
            background: "linear-gradient(180deg, #322a22, #1f1814)",
          }}>
            <div style={{
              position: "absolute", inset: 0, opacity: 0.5,
              backgroundImage: "repeating-linear-gradient(135deg, rgba(216,168,104,0.08) 0px, rgba(216,168,104,0.08) 1px, transparent 1px, transparent 6px)",
              pointerEvents: "none",
            }}/>
            <div style={{ position: "relative" }}>
              <div className="mono" style={{ fontSize: 9.5, color: "var(--m-accent)", letterSpacing: "0.18em", textTransform: "uppercase" }}>EducaFinaz · pedagogical certificate</div>
              <div className="m-serif" style={{ fontSize: 18, marginTop: 14, fontStyle: "normal", lineHeight: 1.3 }}>
                Marta Ortiz ha completado el curso
              </div>
              <div style={{ fontSize: 22, fontWeight: 600, marginTop: 6, letterSpacing: "-0.015em" }}>
                Análisis técnico, iniciación
              </div>
              <div style={{ marginTop: 20, display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div className="mono" style={{ fontSize: 9, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>MASTERY MEDIA</div>
                  <div className="mono" style={{ fontSize: 22, color: "var(--m-positive)", marginTop: 2 }}>84%</div>
                </div>
                <div>
                  <div className="mono" style={{ fontSize: 9, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>TRANSFERENCIAS</div>
                  <div className="mono" style={{ fontSize: 22, color: "var(--m-positive)", marginTop: 2 }}>4 / 5</div>
                </div>
              </div>
              <div className="m-divider" style={{ margin: "16px 0" }}/>
              <div className="mono" style={{ fontSize: 9, color: "var(--m-text-3)", letterSpacing: "0.06em" }}>
                CERT-AT-INI-26-MAY-0017 · no es certificación financiera
              </div>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div style={{ marginTop: 30, display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16 }}>
          {[
            { l: "MASTERY MEDIA", v: "84%", c: "var(--m-positive)", icon: "target" },
            { l: "TRANSFERENCIAS",   v: "4 / 5", c: "var(--m-accent)", icon: "check" },
            { l: "MISCONCEPTIONS RET.", v: "0",     c: "var(--m-positive)", icon: "shield" },
            { l: "TIEMPO TOTAL",        v: "4h 52", c: "var(--m-text)",    icon: "review" },
          ].map((s, i) => (
            <div key={i} className="m-panel" style={{ padding: 18 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div className="mono" style={{ fontSize: 9.5, color: "var(--m-text-3)", letterSpacing: "0.1em" }}>{s.l}</div>
                <Icon name={s.icon} size={14} style={{ color: s.c }}/>
              </div>
              <div className="mono" style={{ fontSize: 28, color: s.c, marginTop: 10, fontWeight: 500 }}>{s.v}</div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 26, display: "grid", gridTemplateColumns: "1.3fr 1fr", gap: 20 }}>
          <div className="m-panel" style={{ padding: 22, border: "1px solid rgba(201,122,75,0.35)" }}>
            <MEye>Próximo curso recomendado</MEye>
            <div style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 14 }}>
              <div style={{
                width: 64, height: 64, borderRadius: 99,
                background: "rgba(201,122,75,0.18)", border: "1.5px solid var(--m-primary)",
                display: "grid", placeItems: "center", fontFamily: "var(--m-t-mono)", fontSize: 16, fontWeight: 600,
                color: "var(--m-primary)",
              }}>AT2</div>
              <div style={{ flex: 1 }}>
                <div className="m-serif" style={{ fontSize: 22, fontStyle: "normal", letterSpacing: "-0.01em" }}>AT medio · combinar evidencia</div>
                <div className="mono" style={{ fontSize: 10.5, color: "var(--m-text-3)", marginTop: 4 }}>~7 h · 8 módulos · proyecto: regla verificable</div>
              </div>
              <button className="m-btn primary"><Icon name="next" size={13}/></button>
            </div>
          </div>

          <div className="m-panel" style={{ padding: 22 }}>
            <MEye>Repaso espaciado · activo</MEye>
            <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 6 }}>
              {[
                { d: "Día 1", t: "1 flashcard", on: true },
                { d: "Día 4", t: "micro-quiz · 3 ej.", on: false },
                { d: "Día 10", t: "transferencia", on: false },
                { d: "Día 30", t: "consolidación", on: false },
              ].map((r, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, fontSize: 12.5 }}>
                  <span className="mono" style={{ width: 50, fontSize: 10, color: r.on ? "var(--m-accent)" : "var(--m-text-3)" }}>{r.d}</span>
                  <span style={{ flex: 1, color: "var(--m-text-2)" }}>{r.t}</span>
                  {r.on ? <MChip variant="warn">próximo</MChip> : <Icon name="circle" size={11} style={{ color: "var(--m-text-3)" }}/>}
                </div>
              ))}
            </div>
            <div className="m-divider" style={{ margin: "14px 0" }}/>
            <button className="m-btn ghost sm" style={{ width: "100%" }}><Icon name="profile" size={11}/> Pausar repaso desde perfil</button>
          </div>
        </div>

        <div style={{ marginTop: 30, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Icon name="shield" size={13} style={{ color: "var(--m-text-3)" }}/>
            <MNotAdvice>Certificado pedagógico · no constituye certificación financiera ni habilitación profesional</MNotAdvice>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="m-btn"><Icon name="save" size={13}/> Descargar PDF</button>
            <button className="m-btn"><Icon name="share" size={13}/> Compartir</button>
          </div>
        </div>
      </div>
    }
  />
);
